"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { Skeleton } from "../ui/skeleton";
export function BackButton(t0) {
  const $ = _c(3);
  const {
    defaultHref
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="w-40 h-8 mb-2 sm:mb-6" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== defaultHref) {
    t2 = <Suspense fallback={t1}><Component defaultHref={defaultHref} /></Suspense>;
    $[1] = defaultHref;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function Component(t0) {
  const $ = _c(6);
  const {
    defaultHref
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("backButtonUrl");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const backButtonUrl = t1;
  let backButtonHref = defaultHref;
  if (backButtonUrl) {
    backButtonHref = backButtonUrl;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ArrowLeft />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = backButtonHref !== defaultHref ? "Back" : "Back to All Posts";
  let t4;
  if ($[3] !== backButtonHref || $[4] !== t3) {
    t4 = <Button variant="outline" size="sm" className="mb-2 sm:mb-6" asChild={true}><Link href={backButtonHref}>{t2}{t3}</Link></Button>;
    $[3] = backButtonHref;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}